import axios from 'axios';
const {
  get
} = axios;
export const getToken = () => document.querySelector('[name="csrf-token"]').content;
const buildHeaders = () => ({
  headers: {
    'Content-Type': 'application/json',
    'X-CSRF-Token': getToken()
  }
});
export const clientFetch = url => get(url, buildHeaders());
export const fetchReferenceDataColumns = (endpoint = `/reference_data_column_caches.json?reference_data_id=`, refId) => {
  return clientFetch(`${endpoint}${refId}`);
};
export const fetchReferenceDataColumnsFromFile = refId => {
  return clientFetch(`/reference_data_column_caches.json?reference_data_id=${refId}`);
};